import { InMemoryCache, createHttpLink, ApolloClient } from '@apollo/client';

export const spotClient = new ApolloClient({
  cache: new InMemoryCache(),
  fetchOptions: { fetch },
  link: createHttpLink({
    uri: `${process.env.REACT_APP_SPOT_API_HOST}/graphql`
  }),
});